import { Component, Input } from '@angular/core';

@Component({
  selector: 'validation',
  template: `
    <div class="validation">
      <div *ngFor="let message of messages" class="ui-message ui-messages-error">{{message}}</div>
    </div>
  `,
  styles: [`.validation{ font-size: 12px; }`]
})
export class ValidationComponent {
  @Input() messages: Array<string>;
}


// WEBPACK FOOTER //
// ./src/app/base/base-fields/components/validation.ts